import { render, staticRenderFns } from "./App2RoadmapDiamond.vue?vue&type=template&id=8b9460fe&scoped=true&"
import script from "./App2RoadmapDiamond.vue?vue&type=script&lang=js&"
export * from "./App2RoadmapDiamond.vue?vue&type=script&lang=js&"
import style0 from "./App2RoadmapDiamond.vue?vue&type=style&index=0&id=8b9460fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9460fe",
  null
  
)

export default component.exports